import { confirmWebAppReady } from "core/javascriptChannels";
import { useEffect } from "react";
import { AppStatusState } from "core/state/appStatusState";
import { appInsightsLogger } from "core/monitoring/AppInsights";

export const useAppReadyStatus = () => {
  const isMobileApp = !!window.flutter_inappwebview;

  const setAppReady = async () => {
    const hasTriggeredAppReady = AppStatusState.get();
    if (!hasTriggeredAppReady) {
      try {
        await confirmWebAppReady();
        AppStatusState.set("true");
      } catch (error) {
        appInsightsLogger.error("confirmWebAppReady_failed", error);
      }
    }
  };

  useEffect(() => {
    if (isMobileApp) {
      setAppReady();
    }
  }, [isMobileApp]);
};
